import React from 'react';
import styled from 'styled-components';

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale);

interface MobileLeaderboardPointsHistoryChartProps {
  weeklyPointsHistory?: Array<{ week_start: string; points: number }>;
}

const MobileLeaderboardPointsHistoryChart: React.FC<MobileLeaderboardPointsHistoryChartProps> = ({
  weeklyPointsHistory = [],
}) => {
  const labels = weeklyPointsHistory.map(item => item.week_start);
  const data = {
    labels,
    datasets: [
      {
        label: 'Points',
        data: weeklyPointsHistory.map(item => item.points),
        borderColor: 'rgba(59, 130, 246, 1)',
        backgroundColor: 'rgba(59, 130, 246, 0.12)',
        tension: 0.3,
        fill: false,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: 'rgba(59, 130, 246, 1)',
        pointBorderColor: '#ffffff',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        bodyFont: {
          family: 'Poppins',
          size: 12,
        },
        titleFont: {
          family: 'Poppins',
          size: 14,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 8,
          font: {
            family: 'Poppins',
            size: 11,
          },
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Points',
          font: {
            family: 'Poppins',
            size: 12,
          },
        },
        ticks: {
          font: {
            family: 'Poppins',
            size: 11,
          },
        },
      },
    },
  };

  return (
    <ChartWrapper>
      <Line data={data} options={options} />
    </ChartWrapper>
  );
};

const ChartWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  height: 160px;
  overflow: hidden;
  box-sizing: border-box;

  canvas {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
  }
`;

export default MobileLeaderboardPointsHistoryChart;
